import React from 'react';

export function onFocusScrollIntoCenter(ev: React.FocusEvent) {
  ev.target.scrollIntoView?.({ block: 'center' });
}
